window.addEventListener('load', function () {
  const observer = new MutationObserver((mutations, obs) => {
    const gwWidget = document.querySelector('.gw-rv-star-rating-widget-placeholder');
    if (!gwWidget) return; // seguimos esperando

    // Widget detectado, desconectamos observer
    obs.disconnect();

    const hasReviews = gwWidget.shadowRoot?.querySelector('.gw-rv-star-rating-widget');

    if (hasReviews) {
      // Ocultar resumen si hay reviews
      document.querySelector('.product-review-summary').style.display = 'none';
      document.querySelector('.section-testimonials-video').style.display = 'none';
      console.log('product-review-summary oculto porque hay reviews');
    } else {
      // Mostrar resumen si NO hay reviews
      document.querySelector('.product-review-summary').style.display = 'flex';
      console.log('no hay reviews, product-review-summary visible');
    }
  });

  // Observamos todo el body en busca de cambios
  observer.observe(document.body, { childList: true, subtree: true });
});


/*****************************************************
 AB - STICKY ATC
*****************************************************/

window.addEventListener('load', () => {
  const host = document.querySelector('.gw-rd-popup-widget-placeholder');
  const shadow = host?.shadowRoot;

  if (shadow) {
    const style = document.createElement('style');

    style.textContent = `
      .gw-rd-popup-widget-launcher-btn--BR {
        bottom: 180px !important;
        right: 20px !important;
      }

      @media screen and (min-width: 991px) {
        .gw-rd-popup-widget-launcher-btn--BR {
          bottom: 130px !important;
        }
      }
    `;

    shadow.appendChild(style);
  }

  function popUP() {
    let hostN = document.querySelector('.gw-nudges-popup-widget-placeholder');
    let shadowNudge = hostN?.shadowRoot;
    
    if (shadowNudge) {
      let style = document.createElement('style');

      style.textContent = `
        .gw-nudges-popup-widget-container--BR {
          bottom: 200px !important;
        }

        @media (max-width: 550px) {
            .gw-nudges-popup-widget-container--BR {
              bottom: 250px !important;
            }
        }
      `;

      shadowNudge.appendChild(style);
    }
  }
  setTimeout(popUP, 20000);
});